import { cva } from "styled-system/css";

export const button = cva({
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "sm",
    borderRadius: "medium",
    borderWidth: 0,
    cursor: "pointer",
    fontFamily: "sans",
    fontSize: "base",
    fontWeight: 700,
    paddingY: "sm",
    paddingX: "md",
    transitionProperty: "background-color, color, opacity",
    transitionDuration: "0.2s",
    userSelect: "none",
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.5,
    },
  },
  variants: {
    variant: {
      primary: {
        backgroundColor: "primary",
        color: "primaryContent",
        _hover: { opacity: 0.9 },
      },
      secondary: {
        backgroundColor: "secondary",
        color: "secondaryContent",
        _hover: { opacity: 0.9 },
      },
      outline: {
        backgroundColor: "transparent",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "primary",
        color: "primary",
        _hover: {
          backgroundColor: "primary",
          color: "primaryContent",
        },
      },
      ghost: {
        backgroundColor: "transparent",
        color: "inherit",
        _hover: {
          backgroundColor: "bgBase200",
        },
      },
      danger: {
        backgroundColor: "error",
        color: "#ffffff",
        _hover: { opacity: 0.9 },
      },
    },
    size: {
      small: {
        fontSize: "sm",
        paddingY: "xs",
        paddingX: "sm",
      },
      medium: {},
      large: {
        fontSize: "h3",
        paddingY: "md",
        paddingX: "lg",
      },
    },
    fullWidth: {
      true: {
        display: "flex",
        width: "100%",
      },
    },
  },
});
